import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SharedService } from './shared.service';
import { catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Injectable()
export class WalletService {

  private jsonOptions = {
    headers: new HttpHeaders().set('Accept', 'application/json').set('Content-Type', 'application/json')
  };

  constructor(private http: HttpClient, private sharedService: SharedService) {}

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      //console.error(error); // log error to console

      // Let the app keep running by returning an empty result.
      return of(error as T);
    };
  }

  public getWallet(userId:any) {
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'wallet/'+userId, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getWalletTransactions', {})),
    );
  }

  public getWalletTransactions(userId:any,filter:any) {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'wallet/transactions/' + userId, filter,this.jsonOptions).pipe(
      catchError(this.handleError<any>('getWalletTransactions', {}))
    );
  }

  public preLoadWalletRequest(walletRequest:any) {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'wallet/load/wallet', walletRequest, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getWalletTransactions', {}))
    );

  }

   public preLoadStoreWalletRequest(institutionId :any, storeId:any, walletRequest:any) {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'institution/'+institutionId+'/store/'+storeId+'/load/wallet', walletRequest, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getWalletTransactions', {}))
    );

  }

  public getStoreWalletTransactions(institutionId:any, storeId:any,filter:any) {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'institution/'+institutionId+'/store/wallet/transactions/' + storeId, filter,this.jsonOptions).pipe(
      catchError(this.handleError<any>('getStoreWalletTransactions', {}))
    );
  }

  public generateTransaction(userId:any,filter:any): Observable<any> {
    return this.http.post(
      this.sharedService.getFranchiseUrl() + 'wallet/transactions/generate/'+userId,filter,
      this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('generateTransaction', []))
    );
  }

  public generateInsStoreWalletTransaction(insId:any, storeId:any,filter:any): Observable<any> {
    return this.http.post(
      this.sharedService.getFranchiseUrl() + 'institution/'+insId+'/store/'+storeId+'/wallet/transactions/generate',filter,
      this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('generateTransaction', []))
    );
  }
}
